import { render, staticRenderFns } from "./onereservations.vue?vue&type=template&id=62abf63a&scoped=true&"
import script from "./onereservations.vue?vue&type=script&lang=js&"
export * from "./onereservations.vue?vue&type=script&lang=js&"
import style0 from "./onereservations.vue?vue&type=style&index=0&id=62abf63a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62abf63a",
  null
  
)

export default component.exports